/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Current_Pain_ShortInputs */

const en_us2_intake_why_current_pain_short = /** @type {(inputs: Intake_Why_Current_Pain_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removes what would hurt`)
};

const pt_br2_intake_why_current_pain_short = /** @type {(inputs: Intake_Why_Current_Pain_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove o que doeria`)
};

const es_419_intake_why_current_pain_short = /** @type {(inputs: Intake_Why_Current_Pain_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quita lo que dolería`)
};

const pt_pt2_intake_why_current_pain_short = /** @type {(inputs: Intake_Why_Current_Pain_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove o que doeria`)
};

const fr_fr2_intake_why_current_pain_short = /** @type {(inputs: Intake_Why_Current_Pain_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retire ce qui ferait mal`)
};

const de_de2_intake_why_current_pain_short = /** @type {(inputs: Intake_Why_Current_Pain_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernt, was wehtun würde`)
};

const it_it2_intake_why_current_pain_short = /** @type {(inputs: Intake_Why_Current_Pain_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toglie ciò che farebbe male`)
};

/**
* | output |
* | --- |
* | "Removes what would hurt" |
*
* @param {Intake_Why_Current_Pain_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_current_pain_short = /** @type {((inputs?: Intake_Why_Current_Pain_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Current_Pain_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_current_pain_short(inputs)
	if (locale === "es-419") return es_419_intake_why_current_pain_short(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_current_pain_short(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_current_pain_short(inputs)
	if (locale === "de-DE") return de_de2_intake_why_current_pain_short(inputs)
	if (locale === "it-IT") return it_it2_intake_why_current_pain_short(inputs)
	return en_us2_intake_why_current_pain_short(inputs)
});
export { intake_why_current_pain_short as "intake.why.current_pain.short" }